<template>
  <footer class="main-footer section mt-auto">
    <div class="container _xl flex flex-col items-center">
      <div class="brand">
        <img src="/svg/supranet-v2.svg" alt />
      </div>

      <div class="flex items-center justify-center flex-wrap mb-2 md:mb-6">
        <router-link
          class="text-white hover:text-primary font-light"
          :to="{ name: 'index' }"
        >Naslovnica</router-link>
        <router-link
          class="text-white hover:text-primary font-light ml-2 md:ml-4 xxl:ml-8"
          :to="{ name: 'about' }"
        >O nama</router-link>
        <router-link
          class="text-white hover:text-primary font-light ml-2 md:ml-4 xxl:ml-8"
          :to="{ name: 'projects' }"
        >Projekti</router-link>
        <router-link
          class="text-white hover:text-primary font-light ml-2 md:ml-4 xxl:ml-8"
          :to="{ name: 'suprasolar' }"
        >SupraSolar</router-link>
        <router-link
          class="text-white hover:text-primary font-light ml-2 md:ml-4 xxl:ml-8"
          :to="{ name: 'services' }"
        >Usluge</router-link>
        <a
          class="text-white hover:text-primary font-light ml-2 md:ml-4 xxl:ml-8"
          href="https://storm-grupa.talentlyft.com/supra-net#home"
          target="_blank"
        >Posao</a>
        <!-- <router-link
          class="text-white hover:text-primary font-light ml-2 md:ml-4 xxl:ml-8"
          :to="{ name: 'jobs' }"
        >Posao</router-link> -->
        <router-link
          class="text-white hover:text-primary font-light ml-2 md:ml-4 xxl:ml-8"
          :to="{ name: 'contact' }"
        >Kontakt</router-link>
        <router-link
          class="text-white hover:text-primary font-light ml-2 md:ml-4 xxl:ml-8"
          :to="{ name: 'reference' }"
        >Reference</router-link>
        <router-link
          class="text-white hover:text-primary font-light ml-2 md:ml-4 xxl:ml-8"
          :to="{ name: 'privacy-policy' }"
        >Pravila privatnosti</router-link>
      </div>

      <div class="my-2 md:my-6 flex items-center justify-center">
        <a href="https://www.facebook.com/Supra-Net-648343745582091/?view_public_for=648343745582091" target="_blank">
          <img src="/svg/logos/facebook.svg" alt="Facebook" />
        </a>
        <a href="https://www.linkedin.com/company/19048096/" target="_blank" class="ml-2">
          <img src="/svg/logos/linkedin.svg" alt="LinkedIn" />
        </a>
      </div>

      <div class="my-2 md:my-4 w-full flex items-center justify-center flex-wrap">
        <div class="w-full relative mb-2 flex items-center justify-center">
          <span class="italic font-bold text-lg bg-secondary p-2 z-1 sm:px-4">STORM Grupa</span>
          <span class="block w-full h-px bg-gray-700 absolute inset-0 m-auto z-under"></span>
        </div>

        <div class="w-full flex items-center justify-center md:justify-between flex-wrap xxl:mx-16">
          <img src="/svg/logos/storm-computers.svg" alt="STORM Computers" class="max-h-logo px-2 my-2" />

          <img src="/svg/logos/supranet.svg" alt="Supra Net" class="max-h-snet px-2 my-2" />

          <img src="/svg/logos/proaxis.svg" alt="Proaxis" class="max-h-logo px-2 my-2" />

          <img src="/svg/logos/databox.svg" alt="Databox" class="max-h-logo px-2 my-2" />

          <img src="/svg/logos/notus.svg" alt="Notus" class="max-h-logo px-2 my-2" />

          <img src="/svg/logos/rinels.svg" alt="Rinels" class="max-h-logo px-2 my-2" />

          <img src="/svg/logos/supracontrol.svg" alt="SupraControl" class="max-h-logo px-2 my-2" />

          <img src="/svg/logos/poligon.svg" alt="Poligon" class="max-h-logo px-2 my-2" />

          <img src="/svg/logos/storm-ict.svg" alt="STORM ICT" class="max-h-logo px-2 my-2" />
        </div>

        <div class="w-full h-px bg-gray-700 mt-4"></div>
      </div>

      <div class="mt-2 md:mt-6 flex flex-col text-xs text-gray-300 text-center">
        <span>Supra Net d.o.o. - Koledovčina 1d 10 000 Zagreb, OIB: 43340124580</span>
        <span>&copy; {{ date.getFullYear() }} Supra Net</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
    data() {
        return {
            date: new Date(),
        }
    }
};
</script>
